import { useEffect, useState } from "react";
import { Shield, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const readInfo = () => {
      try {
        const raw = localStorage.getItem("impersonation_info");
        setInfo(raw ? JSON.parse(raw) : null);
      } catch {
        setInfo(null);
      }
    };
    readInfo();
    window.addEventListener("storage", readInfo);
    return () => window.removeEventListener("storage", readInfo);
  }, []);

  if (!info) return null;

  const handleRevert = () => {
    try {
      const adminToken = localStorage.getItem("admin_token_backup");
      if (!adminToken) {
        toast.error("Admin-token mangler. Logg inn på nytt som admin.");
        localStorage.removeItem("impersonation_info");
        window.location.href = "/login";
        return;
      }
      localStorage.setItem("scaffoldx_token", adminToken);
      localStorage.removeItem("admin_token_backup");
      localStorage.removeItem("impersonation_info");
      toast.success("Tilbake til admin-konto");
      window.location.href = "/admin/marketplace";
    } catch (e) {
      toast.error("Kunne ikke gå tilbake til admin");
    }
  };

  const targetName =
    info.company_name ||
    info.target_user?.name ||
    info.seller_code ||
    "selger";

  return (
    <div
      className="sticky top-0 z-[100] bg-gradient-to-r from-[#F7931A] via-[#FFCD00] to-[#F7931A] text-black shadow-lg"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-medium min-w-0">
          <Shield className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">
            <span className="hidden sm:inline">Admin-modus:</span> Du opptrer som{" "}
            <strong className="font-semibold">{targetName}</strong>
            {info.seller_code && (
              <span className="opacity-75 ml-2 font-mono text-xs">
                ({info.seller_code})
              </span>
            )}
          </span>
        </div>
        <button
          onClick={handleRevert}
          className="flex items-center gap-2 bg-black/80 hover:bg-black text-white text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-md transition-colors whitespace-nowrap"
          data-testid="revert-impersonation-btn"
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Tilbake til Admin</span>
          <span className="sm:hidden">Exit</span>
        </button>
      </div>
    </div>
  );
}
